<ph-stack gap="tight">
    <ph-label *ngIf="section.label">{{ section.label }}</ph-label>
    <ph-alert [status]="section.tone === 'warning' ? 'warning' : 'information'" variant="lighter" size="small">{{ section.body }}</ph-alert>
</ph-stack>
